import React from "react";
import { FaSchool, FaUserGraduate, FaClipboardList } from "react-icons/fa6";
import banner10 from "../assets/banner10.jpg";

export default function SMIS() {
  const features = [
    { icon: <FaSchool size={20} className="text-primary" />, text: "Manage student enrollment, academic records, and attendance digitally." },
    { icon: <FaUserGraduate size={20} className="text-primary" />, text: "Track examination results and academic performance efficiently." },
    { icon: <FaClipboardList size={20} className="text-primary" />, text: "Facilitate fee management and communication between stakeholders." },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">School Management Information System (SMIS)</h2>
          <p className="section-copy">
            Implementation of digital platforms for managing student enrollment, academic records, attendance tracking, examination results, fee management, and communication.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner10} alt="SMIS" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            SMIS streamlines school operations, improves administrative efficiency, and enhances communication between teachers, students, and parents.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map(item => (
              <li key={item.text} className="detail-feature-item">{item.icon}<span>{item.text}</span></li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Analyze school administrative processes and workflows.</li>
            <li>Set up modules for student management, academics, and attendance.</li>
            <li>Integrate fee collection, communication, and reporting systems.</li>
            <li>Train staff, teachers, and administrators for seamless adoption.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}